export default {
  main: {
    hero: `
      Découvrez nos<br/>
      mondes <strong>colorés</strong><br/>
      peuplés de<br/>
      personnages <strong>charmants</strong>
      `,
    homescapes: `Un épisode épique de la série des Scapes™, dans lequel les joueurs et joueuses doivent restaurer un superbe manoir aux côtés d'Austin le majordome`,
    township: `Un jeu passionnant de construction de ville bourré d'événements, de compétitions et de tournois JcJ`,
  },
  common: {
    login: 'Se connecter',
    logout: 'Se déconnecter',
    support: 'Service client',
    privacy: 'Politique de confidentialité',
    terms: `Conditions d'utilisation`,
    and: 'et',
    guest: 'Invité·e',
    play: 'Jouer',
    install: 'Installer',
  },
  support: {
    title: `Besoin d'aide?`,
    description: `Si vous jouez à ce jeu et que vous rencontrez des difficultés,
      nous serons heureux de vous aider et de répondre à vos questions.`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Aidez Austin le majordome à ramener chaleur et confort au superbe manoir de ses parents.',
    description: `Aidez Austin le majordome à ramener chaleur et confort
      au superbe manoir de ses parents. Rejoignez-nous, des aventures
      vous attendent dès le pas de la porte!`,
    xsolla: 'Xsolla est un distributeur mondial autorisé de Homescapes',
    install: {
      title: '@:common.install',
      text: `Homescapes sur votre bureau !
      Installez la version web du jeu et rendez visite à Austin d'un simple clic !`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: `Construisez la ville de vos rêves!
      Transformez le fruit de vos récoltes en produits
      que vous pourrez vendre pour développer votre ville.`,
    description: `Construisez la ville de vos rêves!
      Transformez le fruit de vos récoltes en produits
      que vous pourrez vendre pour développer votre ville.`,
    xsolla: 'Xsolla est un distributeur mondial autorisé de Township',
    install: {
      title: '@:common.install',
      text: `Township sur votre bureau!
      Installez la version web du jeu et visitez votre ville en quelques clics seulement!`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: 'Ce site utilise des cookies pour vous assurer la meilleure expérience sur notre site',
    link: `Plus d'infos`,
    button: 'Accepter',
  },
  game: {
    notSupported: `Les appareils mobiles ne sont pas pris en charge.
      Pour jouer, connectez-vous sur un ordinateur.`,
  },
};
